import { Injectable, inject } from '@angular/core';
import { DeviceInfo } from '../deviceInfo.service';
import { LoadingService } from '../loading.service';
import { DeviceInfoService } from '../deviceInfo.service';
import { ErrorData } from './error-handler.base.service';
import { Firestore, collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { Functions, httpsCallable } from 'firebase/functions';
import { FIREBASE_FIRESTORE, FIREBASE_FUNCTIONS } from '@awo-care/shared-firebase';

@Injectable({
  providedIn: 'root',
})
export class SendErrorMessageService {
  loadingService = inject(LoadingService);
  firestore: Firestore = inject(FIREBASE_FIRESTORE);
  private functions = inject(FIREBASE_FUNCTIONS);
  private deviceInfoService = inject(DeviceInfoService);

  uiErrorCollection = collection(this.firestore, 'uiErrorLog');

  async sendError(errorData: ErrorData): Promise<void> {
    try {
      this.loadingService.setLoading(true);

      if (!errorData.errorData) {
        throw new Error('Missing Error Data');
      }

      const serializableErrorData = JSON.parse(
        JSON.stringify(errorData.errorData)
      );
      delete serializableErrorData.screenshot;

      const deviceInfo = this.deviceInfoService.getDeviceInfo() as DeviceInfo;

      const errorMessage = {
        createdOn: serverTimestamp(),
        comment: errorData.comment,
        errorData: serializableErrorData,
        tierName: errorData.tierName,
        appType: errorData.appType,
        appVersion: errorData.appVersion,
        uid: errorData.uid,
        userEmail: errorData.userEmail,
        deviceInfo,
      };

      const docRef = doc(this.uiErrorCollection);
      await setDoc(docRef, errorMessage);

      // Forward to AI Issue Bot (fire-and-forget, errors silently logged)
      this.forwardToAIIssueBot(errorData, deviceInfo);
    } catch (err) {
      console.error(err);
      throw {
        message:
          'Leider ist beim senden ein Fehler aufgetreten. Kontaktieren Sie bitte den Support',
        code: 'SAMPLE_ERROR_CODE',
        cause: new Error('Fehler beim Senden des Fehlers'),
        reportError: false,
      };
    } finally {
      this.loadingService.setLoading(false);
    }
  }

  private forwardToAIIssueBot(errorData: ErrorData, deviceInfo: DeviceInfo | null): void {
    try {
      const submitErrorReport = httpsCallable(this.functions, 'submitErrorReport');
      submitErrorReport({ ...errorData, deviceInfo }).then(
        () => {},
        (err) => console.warn('Failed to forward error to AI Issue Bot:', err)
      );
    } catch (err) {
      console.warn('Failed to call submitErrorReport:', err);
    }
  }
}
